import { render } from "./DragButton.vue?vue&type=template&id=c2260e46"
import script from "./DragButton.vue?vue&type=script&lang=js"
export * from "./DragButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__